import "./PaymentUploadedTransacitonsHeader.css";

import { Box, Button, CircularProgress, Grid, Tooltip, Typography, useTheme } from "@mui/material";
import { FC, useEffect, useState } from "react";

import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, EnhancedRadioGroupRHF, RHookFormTextFieldWithLabel, StandardPanel } from "@websential/cosmic-v20";

import { BasicAddRowButtonToolbar } from "../../../../common/BasicAddRowButtonToolbar";
import { VisuallyHiddenInput } from "../../../CountrySetup";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";



let columns = [
	{ field: "file", headerName: "Upload File", minWidth: 500 },
	{ field: "description", headerName: "Description", minWidth: 600 },
];

let emptyPaymentUploadedFields = {
	id: null,
	file: null,
	description: null,
}

interface IPaymentUploadedTransacitonsHeader {
	paymentUploadedTransactionsFieldsTableUpdatedData: (data: any) => void;
	paymentUploadedTransactionsFieldsDataItems: any;
}
export const PaymentUploadedTransacitonsHeader: FC<
	IPaymentUploadedTransacitonsHeader
> = ({ paymentUploadedTransactionsFieldsTableUpdatedData, paymentUploadedTransactionsFieldsDataItems }) => {

	const [PaymentUploadedTransactionsFieldsTable, setPaymentUploadedTransactions] = useState<any>(
		paymentUploadedTransactionsFieldsDataItems
	);

	const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);
	const [paymentUploadedFieldsEmpty, setPaymentUploadedFieldsEmpty] = useState(emptyPaymentUploadedFields);

	useEffect(() => {
		paymentUploadedTransactionsFieldsTableUpdatedData(PaymentUploadedTransactionsFieldsTable);
	}, [PaymentUploadedTransactionsFieldsTable]);

	useEffect(() => {
		setPaymentUploadedTransactions(paymentUploadedTransactionsFieldsDataItems);
	}, [paymentUploadedTransactionsFieldsDataItems]);


	const findIndexById = (id: string | number | any) => {
		let index = -1;

		for (let i = 0; i < PaymentUploadedTransactionsFieldsTable.length; i++) {
			if (PaymentUploadedTransactionsFieldsTable[i].id === id) {
				index = i;
				break;
			}
		}
		return index;
	};

	const createId = () => {
		let id = "";
		let chars =
			"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (let i = 0; i < 5; i++) {
			id += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		return id;
	};

	const openNew = () => {


		if (PaymentUploadedTransactionsFieldsTable && PaymentUploadedTransactionsFieldsTable.length >= 10) return null;

		let _paymentUploadedSetupPanelData = [...PaymentUploadedTransactionsFieldsTable];
		let _paymentUploadedSetupPanelNewRow: any = { ...paymentUploadedFieldsEmpty };

		if (paymentUploadedFieldsEmpty.id) {
			const rowIndex = findIndexById(paymentUploadedFieldsEmpty.id);
			_paymentUploadedSetupPanelData[rowIndex] = _paymentUploadedSetupPanelNewRow;
		
		} else {
			const newRowId = createId();
			_paymentUploadedSetupPanelNewRow.id = newRowId;
			_paymentUploadedSetupPanelData.push(_paymentUploadedSetupPanelNewRow);
			setLastAddedRowId(newRowId && newRowId);
			
		}
		setPaymentUploadedTransactions(_paymentUploadedSetupPanelData);
		setPaymentUploadedFieldsEmpty(emptyPaymentUploadedFields);
	};


	const onCellValueChange = (event: any, rowIndex: number, field: any) => {

		setPaymentUploadedTransactions((prev: any) => {
			const updatedData = [...prev];

		
			const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
		
			updatedData[rowIndex] = updatedRow; // ✅ Replace with new object (triggers re-render)
			return updatedData;
		});
	};

	// const onDeleteNewAddedRow = (rowId: any) => {
	// 	setPaymentUploadedTransactions((prev: any[]) => {
	// 		const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

	// 		if (rowDeleteBasedOnId.length > 1) {
	// 			const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
	// 			setLastAddedRowId(lastRowId);
	// 		} else {
	// 			setLastAddedRowId(null);
	// 		}
	// 		return rowDeleteBasedOnId;
	// 	});
	// }

	const onDeleteNewAddedRow = (rowId: any) => {
		setPaymentUploadedTransactions((prev: any[]) => {
			const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);
			if (rowId === lastAddedRowId) {
				const nextAddedRow = [...rowDeleteBasedOnId]
					.reverse()
					.find((row) => !paymentUploadedTransactionsFieldsDataItems.some((initial: any) => initial.id === row.id));
				setLastAddedRowId(nextAddedRow ? nextAddedRow.id : null);
			}
			return rowDeleteBasedOnId;
		});
	};

	const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
		if (field.field === "file") {
			if (
				rowData.file !== "" &&
				rowData.file !== undefined &&
				rowData.file !== null
			) {
				if (rowData.file === null) {
					return "p-component p-filled calender-error-input";
				} else if (rowData.paymentStartDate === "") {
					return "p-component p-filled calender-error-input";
				}
			}
		} else if (field.field === "description") {
			if (
				rowData.description !== "" &&
				rowData.description !== undefined &&
				rowData.description !== null
			) {
				if (rowData.description === null) {
					return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
				} else if (rowData === "") {
					return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
				}
			} else {
				return "p-component p-filled input-dropdown-fields .p-dropdown";
			}
		} else {
			return "p-component p-filled input-dropdown-fields";
		}
	};

	const columnsBody = (rowData: any, row: any, x: any) => {
		if (x.field === "file") {
			return (
				<Grid
					container
					size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
					sx={{ alignItems: "center", }}
				>
					{/* <Grid size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}>
						<Typography sx={{
							color: "rgba(0,0,0,.6)",
							fontSize: ".875rem",
							}}>TD1 PDF File</Typography>
						</Grid> */}

					<Grid size={{ xs: 12, sm: 12, md: 10.5, lg: 10.5, xl: 10.5 }}>
						<Box sx={{ p: "12px" }}>
							<Button
								component="label"
								role={undefined}
								variant="contained"
								tabIndex={-1}
								// startIcon={<CloudUploadIcon />}
								sx={{ padding: "0px 7px 0px 10px", fontSize: "small" }}
							>
								Upload file
								<VisuallyHiddenInput
									id={`file-${rowData.id}`}
									type="file"
									accept="all"

									onChange={(e: any) => {
										const file = e.target.files?.[0];
									
										if (file) {
											onCellValueChange(
												x,
												row.rowIndex,
												file
											);
										}
									}}
								/>
							</Button>
							<label
								htmlFor={`file-${rowData.id}`}
								style={{
									color: "rgba(0,0,0,.6)",
									cursor: "pointer",
									paddingLeft: "5px",
								}}
							>
								{rowData.file
									? rowData.file.name
									: "Choose a file"}
								{/* {"Choose a file"} */}
							</label>
						</Box>
					</Grid>
				</Grid>


			);
		} else if (x.field === "description") {
			return (
				<InputTextarea
					value={rowData[x.field]}
					onChange={(e: any) => {
					
						onCellValueChange(x, row.rowIndex, e.target.value);
					}}
					placeholder="Detail"
					className={renderErrorClass(x, row.rowIndex, rowData)}
					style={{ height: "2.4rem", padding: "8px" }}
					rows={1}
					cols={60}
				/>
			);
		}
	};



	return (
		<>
			<Grid className="card" sx={{
				background: "#fff",
				border: "1px solid #e5e7eb",
				borderBottom: 0,
				borderRadius: "2px 2px 0 0",
				padding: "31px 20px 1rem 20px",
				marginBottom: "0px!important",
				"& .MuiToolbar-root": { width: "70%" }
			}}>
				<BasicAddRowButtonToolbar
					openNew={openNew}
				/>
				<DataTable
					value={PaymentUploadedTransactionsFieldsTable}
					dataKey="id"
					key={lastAddedRowId}
					showGridlines
					className="PaymentUploadedTransacitonsHeader"
					editMode="cell"
					columnResizeMode="expand"
					scrollable
					// reorderableColumns
					filterDisplay="menu"
					scrollHeight="640px"
				>
					{columns.map((x: any, index: any) => {
						return (
							<Column
								key={index}
								field={x.field}
								header={x.headerName}
								columnKey={x.field}
								style={{
									fontSize: "0.875rem",
									width: x.minWidth
								}}
								body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
							/>
						);
					})}

					{lastAddedRowId && <Column
						body={(rowData: any, row: any) => {
							const showIcon = rowData.id === lastAddedRowId;
							
						
							return showIcon ? (
								<EnhancedButtonPrimeReact
									icon="pi pi-times"
									severity={EnhancedButtonPrimeReactSeverity.Danger}
									className="p-button-rounded p-button-text shadow-none bg-transparent"
									rounded
									onClickHandler={() => onDeleteNewAddedRow(rowData.id)}
								/>
							) : null;
						}}
					/>}


				</DataTable>

				<EnhancedButtonPrimeReact
					label="Upload File"
					raised
					type="submit"
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginTop: "1rem" }}
				/>
			</Grid>
		</>
	);
};
